import {Button, Form, Input, message} from 'antd';
import React, {useEffect, useState} from 'react';
import {handleChangePassword, updateUserDB} from '../common/ChangeAndUpdatePassword';
import {aesDecrypt, aesEncrypt} from '../common/EncodeDecodeMethod';
import {Arguments} from '../common/Arguments';
import {RealtimeGetMethod} from '../common/ApiMethod';

const layout = {
	labelCol: {span: 8},
	wrapperCol: {span: 16},
};

const tailLayout = {
	wrapperCol: {offset: 8, span: 16},
};

const ChangePassword = () => {
	const [form] = Form.useForm();
	const [saveButton, setSaveButton] = useState(false);
	const [currentUser, setCurrentUser] = useState([]);
	const getApi = Arguments.host + '/society_organization/policy/api!allUsers.do';
	const nickname = sessionStorage.getItem('ghost');

	useEffect(() => {
		// 注意：过滤后的值依然是个列表，如果作为 obj 对象使用，应使用 currentUser[0]
		RealtimeGetMethod(getApi).then(resultList =>
			setCurrentUser(resultList.filter(user => user.nickname === nickname)));
	}, [getApi]);

	const onFinish = (formData) => {
		if (formData.newPassword !== formData.confirmPassword) {
			message.error('两次输入的密码不一致，请重新输入');
		} else if (formData.newPassword === '123qweAS') {
			message.error('新密码不能与初始密码相同！');
		} else {
			// 向用户中心发送修改密码的请求
			const encodeOldPassword = sessionStorage.getItem('shadow');
			const oldPassword = aesDecrypt(encodeOldPassword);
			const newPassword = formData.newPassword;
			handleChangePassword(oldPassword, newPassword).then((res) => {
				if (res?.data.code === 1) {
					// 更新 user_info 表
					const objData = {...currentUser[0], password: aesEncrypt(newPassword)};
					updateUserDB(objData);
					message.success('密码修改成功！');
					setTimeout(() => setSaveButton(true), 500);
				}
			});
		}
	};

	const onReset = () => {
		form.resetFields();
	};

	return (
		<>
			<Form
				{...layout}
				form={form}
				name="control-hooks"
				onFinish={onFinish}
				initialValues={{userName: nickname}}
				style={{maxWidth: 400}}
			>
				<Form.Item name="userName" label="用户名" rules={[{required: true, message: '用户名不能为空'}]}>
					<Input disabled={true}/>
				</Form.Item>

				<Form.Item name="newPassword" label="新密码" rules={[{required: true, message: '密码不能为空'}]}>
					<Input.Password showCount={true} placeholder={'至少8位，包含大写字母'}/>
				</Form.Item>

				<Form.Item name="confirmPassword" label="新密码确认"
						   rules={[{required: true, message: '密码不能为空'}]}>
					<Input.Password showCount={true}/>
				</Form.Item>

				<Form.Item {...tailLayout}>
					<Button type="primary" htmlType="submit" disabled={saveButton}>
						保存
					</Button>
					<Button htmlType="button" type="danger" onClick={() => onReset()} style={{marginLeft: 8}}>
						清空
					</Button>
				</Form.Item>
			</Form>
		</>
	);
};

export default ChangePassword;